/** Production timer-v1 behind nekohr (same origin path). */
export const PRODUCTION_TIMER_V1_API_BASE_URL =
  "https://nekohr.nekoapi.xyz/timer-v1/";

/**
 * Timer v1 microservice — set VUE_APP_TIMER_V1_API_BASE_URL to enable.
 * Example local: http://127.0.0.1:3020/
 */
export function getTimerV1ApiBaseUrl() {
  const raw = String(process.env.VUE_APP_TIMER_V1_API_BASE_URL || "").trim();
  if (!raw) return "";
  let base = raw.replace(/\/?$/, "/");
  if (typeof window !== "undefined") {
    const host = window.location.hostname;
    const onLocalDev =
      host === "localhost" || host === "127.0.0.1" || host.endsWith(".local");
    if (
      !onLocalDev &&
      /^(https?:\/\/)?(127\.0\.0\.1|localhost)(:\d+)?/i.test(base)
    ) {
      base = PRODUCTION_TIMER_V1_API_BASE_URL;
    }
  }
  return base;
}

export function isTimerV1Enabled() {
  return Boolean(getTimerV1ApiBaseUrl());
}

/** Poll active session while navbar timer is visible (ms). */
export const TIMER_V1_SYNC_INTERVAL_MS = 15000;
